export const percentageSymbol = '%'

export const plusSymbol = '+'

export const minusSymbol = '-'

export const forwardSlashSymbol = '/'
